// extracted by mini-css-extract-plugin
module.exports = {"root":"change-password_root__WayR_"};